/**
 * Variant ID guard
 * -------------------------------------------------------------------------------------------------------
 * Makes sure the variant that is added to the cart ALWAYS matches the size (option) the customer can see
 * as selected on the product form.
 *
 * Why this exists: on the product page the size buttons are plain radio inputs (name="option1" etc.), so the
 * browser marks a size as selected on its own. The hidden <input name="id"> that actually decides which
 * variant is submitted is only updated by the theme's <variant-picker> script — and that script first has to
 * download /products/<handle>.js before it starts listening for size changes. If the customer taps a size
 * before that request is done (slow mobile connection, in-app browser), or if the browser restores the
 * radio selection after Back / reload while the hidden id falls back to the default, the screen shows e.g.
 * "M" while the hidden id still points to the FIRST variant (XS). Add to cart then silently adds XS.
 *
 * What it does: right before any form is submitted (capture phase, so before the theme's own submit
 * handler), it reads the selected option values, looks up the matching variant in the JSON map rendered by
 * snippets/buy-buttons.liquid (no network request needed) and corrects the id if it does not match.
 * Forms without option inputs or without the JSON map (product cards, gift popup, etc.) are ignored.
 */
(function () {
  'use strict';

  function readSelectedOptions(form) {
    var options = [];

    for (var position = 1; position <= 3; position++) {
      var field = form.elements['option' + position];
      if (!field) break;

      // RadioNodeList.value = value of the checked radio; for a single input/select it is simply its value.
      var value = field.value;
      if (value === undefined || value === null || value === '') return null;

      options.push(value);
    }

    return options.length ? options : null;
  }

  function findVariantId(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var variantOptions = variants[i].options;
      if (!variantOptions || variantOptions.length !== options.length) continue;

      var matches = true;
      for (var j = 0; j < options.length; j++) {
        if (variantOptions[j] !== options[j]) {
          matches = false;
          break;
        }
      }

      if (matches) return String(variants[i].id);
    }

    return null;
  }

  function guardForm(form) {
    var holder = form.querySelector('script[data-variant-guard]');
    if (!holder) return;

    var data;
    try {
      data = JSON.parse(holder.textContent);
    } catch (error) {
      return;
    }
    if (!data || !data.variants) return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var selectedOptions = readSelectedOptions(form);
    if (!selectedOptions) return;

    var correctId = findVariantId(data.variants, selectedOptions);
    if (!correctId || correctId === String(idInput.value)) return;

    console.warn('[variant-guard] Corrected variant id ' + idInput.value + ' -> ' + correctId +
      ' (selected: ' + selectedOptions.join(' / ') + ')');

    idInput.value = correctId;
    idInput.disabled = false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.tagName === 'FORM') guardForm(form);
  }, true);
})();